import styled from 'styled-components';
import { theme } from "../../theme";
export var IconBefore = styled.div.withConfig({
  displayName: "Icons__IconBefore",
  componentId: "vapor__sc-1mwowg0-0"
})(["display:flex;margin-right:", ";margin-left:-", ";"], theme.spaces[4], theme.spaces[4]);
export var IconAfter = styled.div.withConfig({
  displayName: "Icons__IconAfter",
  componentId: "vapor__sc-1mwowg0-1"
})(["display:flex;margin-left:", ";margin-right:-", ";"], theme.spaces[4], theme.spaces[4]);